module.exports = __webpack_public_path__ + "img/slider_d05.3717bba.1e3294f8.png";